import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const CustomerSupport = () => {
  return (
    <Container className="py-5">
      <h1 className="text-center mb-5">Customer Support</h1>

      <Row>
        <Col md={6} className="mb-4">
          <Card className="text-center h-100">
            <Card.Body>
              <i className="fas fa-question-circle fa-3x mb-3"></i>
              <Card.Title>FAQs</Card.Title>
              <Card.Text>
                Find answers to common questions about our products and services.
              </Card.Text>
              <Button variant="primary" as={Link} to="/faq">Go to FAQ</Button>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} className="mb-4">
          <Card className="text-center h-100">
            <Card.Body>
              <i className="fas fa-map-marked-alt fa-3x mb-3"></i>
              <Card.Title>Service Centre</Card.Title>
              <Card.Text>
                Find a service centre near you to get your device repaired.
              </Card.Text>
              <Button variant="primary" as={Link} to="/service-centre">Find a Service Centre</Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col md={6} className="mb-4">
          <Card className="text-center h-100">
            <Card.Body>
              <i className="fas fa-shield-alt fa-3x mb-3"></i>
              <Card.Title>Warranty Information</Card.Title>
              <Card.Text>
                Learn more about our warranty policy and how to register your device.
              </Card.Text>
              <Button variant="primary">Learn More</Button>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} className="mb-4">
          <Card className="text-center h-100">
            <Card.Body>
              <i className="fas fa-life-ring fa-3x mb-3"></i>
              <Card.Title>Contact Support</Card.Title>
              <Card.Text>
                Contact our support team directly for any assistance.
              </Card.Text>
              <Button variant="primary" as={Link} to="/contact">Contact Us</Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default CustomerSupport;
